import Vue from 'vue'
import Vuex from 'vuex'
import publicStore from './public'
import operateStore from './operate/operate'
import { isEmpty } from 'lodash'

export interface UserDeatils {
    manageTopIds: string[] // 拥有管理员权限的文件id集
    powerMap: {
        [key: string]: number[] // 文件对应的权限
    }
    relatedTopIds: string[]
    roles: string[]
    userId: string
    isGetUserDetail: boolean
}
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        currentUser: '',
        userDetails: {},
        hasManageTopIds: false,
        isOnlySuperAdmin: false,
        hasSuperAdmin: false,
        ManageTopIds: [],
        isGetUserDetail:false
        
    },
    mutations: {
        SET_CURRENT_USER(state, data: string) {
            state.currentUser = data
            state.isGetUserDetail=true
        },
        SET_USER_DETAILS(state, data: UserDeatils) {
            state.userDetails = data
            state.hasManageTopIds = !isEmpty(data.manageTopIds)
            state.ManageTopIds = data.manageTopIds as never[]
            state.isOnlySuperAdmin =
                isEmpty(data.manageTopIds) &&
                isEmpty(data.powerMap) &&
                data.roles.length === 1 &&
                data.roles[0] === 'FMS_ADMIN'
            state.hasSuperAdmin = !isEmpty(data.roles) && data.roles.includes('FMS_ADMIN')
        },
    },
    actions: {},
    modules: {
        publicStore,
        operateStore,
    },
})
